/** @file removePrefixed: drops every node, drawable, sheet and clip an attachment flattened in. */
import type { PuppetDoc } from '../puppetDoc/puppetDoc';

/** Removes the members whose name starts with `prefix`, sockets on removed nodes and twin links to them. */
export function removePrefixed(draft: PuppetDoc, prefix: string): void {
  const p = draft.puppet;
  const gone = (n: string): boolean => n.startsWith(prefix);
  p.nodes = Object.fromEntries(Object.entries(p.nodes).filter(([n]) => !gone(n)));
  for (const n of Object.values(p.nodes)) if (n.mirror !== undefined && gone(n.mirror)) delete n.mirror;
  p.drawables = p.drawables.filter((d) => !gone(d.id));
  p.sheets = Object.fromEntries(Object.entries(p.sheets).filter(([s]) => !gone(s)));
  p.sockets = Object.fromEntries(Object.entries(p.sockets).filter(([, n]) => !gone(n)));
  draft.clips = Object.fromEntries(Object.entries(draft.clips).filter(([c]) => !gone(c)));
}
